import { render, staticRenderFns } from "./userReport.vue?vue&type=template&id=1fc08178&scoped=true&"
import script from "./userReport.vue?vue&type=script&lang=js&"
export * from "./userReport.vue?vue&type=script&lang=js&"
import style0 from "./userReport.vue?vue&type=style&index=0&id=1fc08178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc08178",
  null
  
)

export default component.exports